import { FunctionComponent } from 'react'
import { Chip } from '@black-bear-energy/rucksack'
import {
  ChipScale,
  getSiteRFPPhaseLabel,
  SiteRFPPhaseOption,
  LabelVariant,
} from 'components/helpers/getSiteRFPPhaseLabel'

export const SiteRFPPhaseChip: FunctionComponent<SiteRFPPhaseChipProps> = ({
  phase,
  scale = 'medium',
  labelVariant = 'full',
}) => {
  const { labelPadding, fontSize, ...scaleSx } = SCALE_SX[scale]

  return (
    <Chip
      label={getSiteRFPPhaseLabel(phase, scale, labelVariant)}
      sx={{
        ...PHASE_COLORS[phase],
        ...scaleSx,
        fontSize,
        '& .MuiChip-label': {
          paddingLeft: labelPadding,
          paddingRight: labelPadding,
        },
      }}
    />
  )
}

const PHASE_COLORS: Record<
  SiteRFPPhaseOption,
  { color: string; backgroundColor: string }
> = {
  ['preRFP']: {
    color: '#384450',
    backgroundColor: '#D3E5EB',
  },
  ['rfp']: {
    color: '#760961',
    backgroundColor: '#EDBADC',
  },
  ['contracts']: {
    color: '#1A237E',
    backgroundColor: '#BFC7FF',
  },
  ['derisking']: {
    color: '#004D40',
    backgroundColor: '#9FF1DE',
  },
  ['permits']: {
    color: '#311B92',
    backgroundColor: '#D1C4E9',
  },
  ['ntp']: {
    color: '#0D47A1',
    backgroundColor: '#BBDEFB',
  },
  ['preCon']: {
    color: '#BF360C',
    backgroundColor: '#FFCCBC',
  },
  ['construction']: {
    color: '#1B5E20',
    backgroundColor: '#B9F6CA',
  },
  ['complete']: {
    color: '#285C80',
    backgroundColor: '#B9E6F0',
  },
}

const SCALE_SX: Record<
  ChipScale,
  {
    height: string
    minWidth?: string
    padding: string
    labelPadding: string
    fontSize: string
  }
> = {
  medium: {
    height: '32px',
    padding: '4px',
    labelPadding: '6px',
    fontSize: '14px',
  },
  small: {
    height: '24px',
    padding: '3px 4px',
    labelPadding: '6px',
    fontSize: '14px',
  },
  mini: {
    height: '18px',
    minWidth: '18px',
    padding: '2px',
    labelPadding: '3px',
    fontSize: '12px',
  },
}

interface SiteRFPPhaseChipProps {
  phase: SiteRFPPhaseOption
  scale?: ChipScale
  labelVariant?: LabelVariant
}
